import React from 'react';

const plans = [
  {
    name: 'Starter',
    price: '₦19,500',
    tagline: 'New merchants testing',
    details: '3 integrations, 500 messages/mo, basic AI',
    highlight: false,
  },
  {
    name: 'Growth',
    price: '₦49,500',
    tagline: 'Serious revenue growers',
    details: 'Unlimited integrations & messages, full AI, reorder nudges',
    highlight: true,
  },
  {
    name: 'Scale',
    price: '₦99,500',
    tagline: 'Multi-outlet businesses',
    details: 'Everything + priority support, custom AI training, team access',
    highlight: false,
  },
];

const NgPricingSection = () => {
  return (
    <section id="pricing" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-black mb-3">
            Choose Your Growth Plan
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3">
            14-Day Free Trial — full access, no card, cancel anytime.
          </p>
          <p className="text-sm text-emerald-700 font-medium">
            Founding Member Pricing — locked in for life if you join this month.
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-3">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`rounded-3xl border px-5 py-6 flex flex-col shadow-sm ${
                plan.highlight
                  ? 'border-[#8ae690] bg-white shadow-[0_20px_45px_-18px_rgba(0,0,0,0.25)]'
                  : 'border-gray-200 bg-white'
              }`}
            >
              <div className="mb-3">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-black/70">
                  {plan.name}
                </p>
              </div>
              <p className="text-2xl sm:text-3xl font-bold text-black mb-1">{plan.price}</p>
              <p className="text-xs text-gray-600 mb-3">{plan.tagline}</p>
              <p className="text-sm text-gray-700 mb-4 flex-1">{plan.details}</p>
              <a
                href="https://engagement.kolanut.ai/signup"
                target="_blank"
                rel="noopener noreferrer"
                className={`inline-flex items-center justify-center h-11 rounded-full text-sm font-semibold transition-all duration-200 ${
                  plan.highlight
                    ? 'bg-[#8ae690] text-black hover:bg-[#7ad67f]'
                    : 'bg-black text-white hover:bg-gray-900'
                }`}
              >
                Start Free 14-Day Trial
              </a>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto mt-8 space-y-2 text-sm text-gray-800">
          <p className="font-semibold text-black">
            Bonuses when you start today:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Ready-to-use WhatsApp &amp; SMS campaign library (₦250,000 value)</li>
            <li>1-on-1 onboarding call with our Nigerian merchant success team</li>
            <li>First 30 days of AI optimization at no extra cost</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default NgPricingSection;

